import React from 'react';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import fields from './fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import {PSingleLine} from 'components/TypographyShortcuts';
import {useFieldData} from '../hooks';
import {LockableAutoField} from '../fields/AutoField';

const VesselNameFlag = props => {
    const {schema, initialValues} = bootstrapOldForm(
        'Name and Numbers',
        fields
    );
    const [vesselName] = useFieldData('vessel_name');
    const [origin] = useFieldData('origin');
    const isPsix = origin === 'psix';

    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='h6' align='left'>
                Name and Numbers
            </Typography>
            <Typography variant='body1' align='left'>
                Tell us a little about this vessel:
            </Typography>
            <LockableAutoField
                locked={isPsix}
                field={fields.vessel_name}
                name='vessel_name'
                value={vesselName}
            />
            {['flag', 'uniformed_service_vessel']?.map(field => (
                <AutoField field={fields[field]} name={field} key={field} />
            ))}
            <PSingleLine>
                Please enter at least one registration number for this vessel.
            </PSingleLine>
            {[
                'imo_number',
                'mmsi',
                'uscg_official_number',
                'state_registration',
                'other_registration_number',
            ]?.map(field => (
                <AutoField field={fields[field]} name={field} key={field} />
            ))}
            {props.children}
        </Section>
    );
};

export default VesselNameFlag;
